import { Integrations } from "@sentry/tracing";
window.Integrations = Integrations;